import React, { useEffect } from "react";
import { useAuth0 } from "./react-auth0-spa";
import {
  Bookings,
  Header,
  AppLoader,
  Calendly,
  PrivateRoute,
  History,
  Flashcards,
} from "./components";
import { BrowserRouter, Switch } from "react-router-dom";
import "./App.css";
import Profile from "./components/Profile";
import LogRocket from "logrocket";

function App() {
  const { user, loading } = useAuth0();

  useEffect(() => {
    if (!user || !user.email) {
      return;
    }

    LogRocket.identify("123456", {
      email: user.email,
      name: user.name,
    });
  }, [user]);

  if (loading) {
    return <AppLoader />;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Switch>
          <PrivateRoute path="/" exact component={Bookings} />
          <PrivateRoute path="/book-lesson/:lessonType?" component={Calendly} />
          <PrivateRoute path="/profile" component={Profile} />
          <PrivateRoute path="/history" component={History} />
          <PrivateRoute path="/flashcards" component={Flashcards} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
